// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__11XN7","notes":"Notes_notes__2PIDY","note":"Notes_note__2UIe6","markdown":"Notes_markdown__18SCU"};